import { render, staticRenderFns } from "./ContactListV2.vue?vue&type=template&id=0b2f6d05"
import script from "./ContactListV2.vue?vue&type=script&lang=js"
export * from "./ContactListV2.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ContactListV2.vue?vue&type=style&index=1&id=0b2f6d05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports